import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_chemical_value: {
        width: '100%',
        backgroundColor: 'transparent',
    },
    view_chemical_value_title: {
        width: '100%',
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 10,
    },
    text_chemical_value: {
        flexDirection: 'column',
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center",
        alignItems: 'flex-start',
    },
    view_chemical_value_content: {
        margin: '10px 0px !important',
        backgroundColor: 'transparent',
        borderRadius: 10,
        textAlign: 'center',
        verticalAlign: 'center',
        justifyContent: 'center',
    },
    input_data_value: {
        backgroundColor: 'transparent',
        borderColor: '#CDCDCD !important',
        borderWidth: 1,
        padding: '0px 8px !important',
        margin: '0px 5px !important',
        borderRadius: 10,
        textAlign: 'center',
        verticalAlign: 'center',
        '& .MuiOutlinedInput-input': {
            textAlign: 'center',
            color: '#06617c !important',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #06617c !important',
        }
    },
    icon_calculator: {
        color: '#06617c !important',
        margin: '5px 10px !important',
        verticalAlign: 'center',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    grid_item_name_horizon: {
        marginTop: '20px !important',
        flexDirection: 'row',
        width: '100%',
        display: 'flex',
        textAlign: "center",
        alignItems: 'center',
        justifyContent: 'center',
    },
    typography_input_data_value: {
        color: '#06617c !important',
        backgroundColor: 'transparent',
        borderRadius: 10,
        marginBottom: '20px !important',
        textAlign: 'center',
        verticalAlign: 'center',
        justifyContent: 'center',
    },
});

export default useStyles;